module.exports = __webpack_public_path__ + "img/pijltje-klein-down.88092f015e1fabcda403ab4836f0c49a.svg";